module.exports = __webpack_public_path__ + "28b67065/img/cadBim.e369a02a.png";